import React,{Component} from 'react';
import { PDFViewer,Document,Page,Text,View,Image } from '@react-pdf/renderer';
import {Typography} from '@material-ui/core';
import Firma from './Firma Brown.png';
import DBHandler from '../DBHandler';

let URLBASE ='retenciones/';




export default class Retencion extends Component{
    constructor(props){
        super(props);
        this.state={
            nroreten:'',
            op:'',
            fechaop:'',
            importeop:'',
            alicuota:'',
            importereten:'',
            fechapago:'',
            cuit:'',
            razon:'',
            calle:'',
            callenro:'',
            piso:'',
            dpto:'',
            localidad:'',
            provincia:'',
            pais:'',
            concepto:'',
            comprobantes:[],
        }
        this.db = new DBHandler();
        if( props.op !== undefined && props.op !== null){
            this.pedirDatos.bind(this)(props.op,props.tipo_deduc,props.ejercicio,props.tabla);
        }
    }

    componentWillReceiveProps(props){
        
        if( props.op !== undefined && props.op !== null){
            this.pedirDatos.bind(this)(props.op,props.tipo_deduc,props.ejercicio,props.tabla);
        }
    }

    pedirDatos(op,deduc,ejercicio,tabla){
        this.db.enviarPeticion(
            this.cargarDatos.bind(this),
            URLBASE + 'devolverRetencion',
            'POST',
            {
                'nro_op':op,
                'codigo_deduc':deduc,
                'ejercicio':ejercicio,
                'tabla':tabla
            }
        )
    }

    cargarDatos(datos){
        
        this.setState({
            nroreten:datos.nroreten,
            op:datos.op,
            fechaop:datos.fechaop,
            importeop:datos.importeop,
            alicuota:datos.alicuota,
            importereten:datos.importereten,
            fechapago:datos.fechapago,
            cuit:datos.cuit,
            razon:datos.razon,
            calle:datos.calle,
            callenro:datos.callenro,
            piso:datos.piso,
            dpto:datos.dpto,
            localidad:datos.localidad,
            provincia:datos.provincia,
            pais:datos.pais,
            concepto:datos.concepto,
            comprobantes:datos.comprobantes,
        })
    }



    render(){ 

        if (this.state.nroreten === ''){
            return <div style={{verticalAlign:'center',
            textAlign:'center',width:'97vw',height:'95vh'}}>
                <Typography>Esperando Comprobante</Typography>
            </div>
        }


        return  <PDFViewer style={{width:'97vw',height:'95vh'}}>
                    <Document style={{width:'97vw',height:'95vh'}}>
                        <Page size='A4'>
                            <View style={{margin:'20pt'}}>
                                <Encabezado
                                    nroreten={this.state.nroreten}
                                ></Encabezado>
                                <AgenteReten
                                ></AgenteReten>
                                <Contribuyente
                                    cuit={this.state.cuit}
                                    razon={this.state.razon}
                                    calle={this.state.calle}
                                    callenro={this.state.callenro}
                                    piso={this.state.piso}
                                    dpto={this.state.dpto}
                                    localidad={this.state.localidad}
                                    provincia={this.state.provincia}
                                    pais={this.state.pais}
                                ></Contribuyente>
                                <Operacion
                                    op={this.state.op}
                                    fechaop={this.state.fechaop}
                                    importeop={this.state.importeop}
                                    alicuota={this.state.alicuota}
                                    importereten={this.state.importereten}
                                    fechapago={this.state.fechapago}
                                ></Operacion>
                                <Comprobantes
                                    comprobantes={this.state.comprobantes}
                                ></Comprobantes>
                                <Firmas
                                    fechapago={this.state.fechapago}
                                ></Firmas>
                            </View> 
                        </Page>
                    </Document>
                </PDFViewer>
    }
    
}

class Firmas extends Component{

    constructor(props){
        super(props);
        this.state={
            fechapago:props.fechapago,
            //fecha:props.fechapago !== undefined && props.fechapago !== null ? new Date(props.fechapago): '',
        }
        this.dias={
            0:'Domingo',
            1:'Lunes',
            2:'Martes',
            3:'Miercoles',
            4:'Jueves',
            5:'Viernes',
            6:'Sabado'
        }
    }
    
    componentWillReceiveProps(props){
        this.setState({
            fechapago:props.fechapago,
            //fecha:props.fechapago !== undefined && props.fechapago !== null ? new Date(props.fechapago): '',
        })
    }

    render(){
        return  <View style={{flexDirection:'row',position:'absolute',top:'700pt'}}>
                    <View style={{width:'250pt'}}>
                        <View style={{textAlign:'center'}}>
                            <Text style={{borderBottom:'1 solid black',fontSize:'10'}}>
                                Adrogue, {this.state.fechapago}
                            </Text>
                            <Text style={{fontSize:'9'}}>Lugar y Fecha</Text>
                        </View>
                    </View>
                    <View style={{width:'250pt',marginLeft:'50pt',position:'relative',top:'-113pt'}}>
                        <View style={{borderBottom:'1 solid black',textAlign:'center'}}>
                            <Image src={Firma}
                                style={{height:'120pt',width:'105pt',position:'relative',left:'70pt'}}
                            ></Image>
                            
                            <Text style={{fontSize:'6',textAlign:'center'}}>
                                Municipalidad de Alte Brown
                            </Text>
                        </View>
                        <Text style={{fontSize:'9',textAlign:'center'}}>
                            Sello y Firma
                        </Text>
                    </View>
                </View>
    }
}

class Comprobantes extends Component{
    constructor(props){
        super(props);
        this.state={
            comprobantes:props.comprobantes,
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            comprobantes:props.comprobantes,
        })
    }

    render(){
        return <View style={{marginLeft:'40pt',marginTop:'10pt'}}>
                <Text style={{fontSize:'12'}}>COMPROBANTES</Text>
                <View style={{marginLeft:'40pt'}}>
                    {this.state.comprobantes.map((elem,ind)=>
                        <Text style={{fontSize:'11'}}>{elem.tipo} - {elem.nro}  $ {elem.monto.toLocaleString()}</Text>)}
                </View>
        </View>
    }
}

class Contribuyente extends Component{
    constructor(props){
        super(props);
        this.state={
            cuit:props.cuit,
            razon:props.razon,
            calle:props.calle,
            callenro:props.callenro,
            piso:props.piso,
            dpto:props.dpto,
            localidad:props.localidad,
            provincia:props.provincia,
            pais:props.pais

        }
    }

    componentWillReceiveProps(props){
        this.setState({
            cuit:props.cuit,
            razon:props.razon,
            calle:props.calle,
            callenro:props.callenro,
            piso:props.piso,
            dpto:props.dpto,
            localidad:props.localidad,
            provincia:props.provincia,
            pais:props.pais
        })
    }

    render(){
        return <View style={{width:'550pt',marginTop:'10pt'}}>
                <View style={{
                        border:'1 solid black',
                        textAlign:'center',
                        backgroundColor:'lightgray'
                        }}>
                    <Text style={{fontSize:'12'}}>Contribuyente</Text>
                </View>
            <View style={{marginLeft:'40pt',marginTop:'5pt'}}>
                <Text style={{fontSize:'11',marginBottom:'7pt'}}>C.U.I.T. : {this.state.cuit}</Text>
                <Text style={{fontSize:'11',marginBottom:'7pt'}}>Número de Inscripción: {this.state.cuit.replace('-','')}</Text>
                <View style={{flexDirection:'row'}}>
                    <View style={{width:'150pt'}}>
                        <Text style={{fontSize:'11'}}>Apellido y Nombres </Text>  
                        <Text style={{fontSize:'11',marginBottom:'7pt'}}> o Razón Social:</Text>
                    </View>
                    <Text style={{fontSize:'11',paddingTop:'5pt'}}>{this.state.razon} </Text>
                </View>
                
                <View style={{flexDirection:'row'}}>
                    <Text style={{fontSize:'11',marginBottom:'7pt',width:'80pt'}}>Domicilio: </Text>
                    <View>
                        <Text style={{fontSize:'11',marginBottom:'7pt'}}>Calle:  {this.state.calle}</Text>
                        <View style={{flexDirection:'row'}}>
                            <Text style={{fontSize:'11',marginBottom:'7pt',width:'100pt'}}>Nro:  {this.state.callenro}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt',width:'150pt'}}>Piso:  {this.state.piso}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Dpto: {this.state.dpto}</Text>
                        </View>
                        <View style={{flexDirection:'row'}}>
                            <Text style={{fontSize:'11',marginBottom:'7pt',width:'250pt'}}>Localidad:  {this.state.localidad}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Provincia: {this.state.provincia}</Text>
                        </View>
                        <Text style={{fontSize:'11',marginBottom:'7pt'}}>Pais:  {this.state.pais}</Text>
                    </View>
                </View>
            </View>
        </View>
    }
}


class Operacion extends Component{
    constructor(props){
        super(props);
        this.state={
            op:props.op,
            fechaop:props.fechaop,
            importeop:props.importeop,
            alicuota:props.alicuota,
            importereten:props.importereten,
            fechapago:props.fechapago,
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            op:props.op,
            fechaop:props.fechaop,
            importeop:props.importeop,
            alicuota:props.alicuota,
            importereten:props.importereten,
            fechapago:props.fechapago,
        })
    }

    render(){
        return  <View style={{width:'550pt',marginTop:'10pt'}}>
                    <View style={{
                        border:'1 solid black',
                        textAlign:'center',
                        backgroundColor:'lightgray'
                        }}>
                        <Text style={{fontSize:'12'}}>Datos de la Operación</Text>
                    </View>
                    <View style={{marginLeft:'40pt',marginTop:'5pt',flexDirection:'row'}}>
                        <View stlye={{width:'150pt'}}>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Orden de Pago: </Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Fecha: </Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Base Imponible:</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Alicuota:</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Importe Retenido: </Text>
                        </View>
                        <View style={{textAlign:"right",width:'100pt'}}>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>{this.state.op}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>{this.state.fechaop}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>{this.state.importeop.toLocaleString()}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>{this.state.alicuota}</Text>
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>{this.state.importereten.toLocaleString()}</Text>
                        </View>
                        <View>
                            {//espacio a rellenar
                            }
                        </View>
                        <View style={{paddingTop:'-57pt',paddingLeft:'-130pt'}} >
                            <Text style={{fontSize:'11',marginBottom:'7pt'}}>Fecha de Pago:{this.state.fechapago}</Text>
                            
                        </View>
                    </View>
                </View>
    }
}

class AgenteReten extends Component{

    render(){
        return  <View style={{width:'550pt',marginTop:'25pt'}}>
                    <View style={{border:'1 solid black',textAlign:'center',backgroundColor:'lightgray'}}>
                        <Text style={{fontSize:'12'}}> Agente de Retención</Text>
                    </View>
                    <View style={{marginLeft:'40pt',marginTop:'5pt'}}>
                        <Text style={{fontSize:'11',marginBottom:'2pt'}} >C.U.I.T.: 33-99900148-9</Text>
                        <Text style={{fontSize:'11',marginBottom:'2pt'}} >Municipalidad de Almirante Brown</Text>
                    </View>
                    <View style={{flexDirection:'row',marginLeft:'40pt'}}>
                        <Text style={{fontSize:'11',marginBottom:'2pt',width:'80pt'}}>Domicilio</Text>
                        <View>
                            <Text style={{fontSize:'11',marginBottom:'2pt'}}>Calle: Rosales </Text>
                            <Text style={{fontSize:'11',marginBottom:'2pt'}}>Localidad: Adrogue</Text>
                            <Text style={{fontSize:'11',marginBottom:'2pt'}}>País: Argentina</Text>
                        </View>
                        <View>
                            <Text style={{fontSize:'11',marginBottom:'2pt'}}> Nro: 1312</Text>
                            <Text style={{fontSize:'11',marginBottom:'2pt'}}>Provincia: Buenos Aires</Text>
                        </View>
                    </View>
                </View>
    }
}


class Encabezado extends Component{
    constructor(props){
        super(props);
        this.state={
            nro:props.nroreten
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            nro:props.nroreten
        })
    }
    render(){
        return  <View style={{flexDirection:'row'}}>
                    <View style={{flexDirection:'column',
                        display:'block',width:'200pt',border:'2 solid black'}}>
                        <View style={{textAlign:'center',paddingTop:'-2pt'}}>
                            <Text style={{fontSize:'12'}}>Provincia de Buenos Aires</Text>
                        </View>
                        <View  style={{textAlign:'center'}}>
                            <Text style={{fontSize:'13'}}>ARBA</Text>
                        </View>
                        <View  style={{textAlign:'center'}}>
                            <Text style={{fontSize:'12'}}>AGENCIA DE RECAUDACION</Text>
                        </View>
                    </View>
                    <View 
                        style={{textAlign:'center',
                            border:'2 solid black',
                            borderLeft:'0 solid black',
                            width:'100pt'
                        }}>
                        <Text  
                            style={{fontSize:'20',
                                    paddingTop:'-4pt'
                            }}
                        >R 122</Text>
                    </View>
                    <View style={{
                        flexDirection:'column',
                        width:'250pt',
                        textAlign:'center',
                        border:'2 solid black',
                        borderLeft:'0 solid black'
                    }}>
                        <Text style={{fontSize:'11'}}>IMPUESTO SOBRE LOS INGRESOS BRUTOS</Text>
                        <Text style={{fontSize:'12',paddingTop:'-3pt'}}>Comprobante de Retención</Text>
                        <Text style={{fontSize:'12',paddingTop:'-3pt'}}>Nro: {this.state.nro}</Text>
                    </View>
                </View>
    }
}